<template>
  <thead class="bg-gray-50">
    <tr>
      <th
        scope="col"
        class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
      >
        Product
      </th>
      <th scope="col" class="px-4 py-3 text-xs whitespace-nowrap" />
    </tr>
  </thead>
</template>

<script>
export default {};
</script>
